import React, { useState } from "react";
import { motion } from "framer-motion";
import { Recycle, Layers3, Leaf } from "lucide-react";

export const RebuildDesigner = ({ rebuild, stories = 6 }) => {
  const [floors, setFloors] = useState(Math.min(stories, 10));
  const [material, setMaterial] = useState(0);
  const mat = rebuild.recommended_materials[material];
  const carbonSaved = Math.round(rebuild.carbon_saved_tco2e * (floors / stories));

  return (
    <div className="qs-grad-border p-6" data-testid="rebuild-designer">
      <div className="flex items-center gap-2 text-[#00FF7F]">
        <Recycle className="h-5 w-5" /> <span className="text-xs uppercase tracking-widest">Recyclable-Material Rebuild Designer</span>
      </div>
      <div className="grid md:grid-cols-2 gap-8 mt-5">
        <div>
          <label className="block text-xs uppercase tracking-widest text-slate-500 mb-2">Floors: <span className="font-mono text-[#00FFFF]">{floors}</span></label>
          <input data-testid="rebuild-floors" type="range" min={2} max={14} value={floors} onChange={(e) => setFloors(+e.target.value)}
            className="w-full accent-[#00FFFF]" />

          <label className="block text-xs uppercase tracking-widest text-slate-500 mt-5 mb-2">Structural material</label>
          <div className="space-y-2">
            {rebuild.recommended_materials.map((m, i) => (
              <button key={m.name} data-testid={`rebuild-material-${i}`} onClick={() => setMaterial(i)}
                className={`w-full flex items-center justify-between px-4 py-3 border text-sm transition-colors ${material === i ? "border-[#00FF7F] bg-[#00FF7F]/5" : "border-white/10"}`}>
                <span className="flex items-center gap-2"><Layers3 className="h-4 w-4 text-[#00FF7F]" /> {m.name}</span>
                <span className="font-mono text-xs text-slate-400">{m.recyclable_pct}% recyclable</span>
              </button>
            ))}
          </div>

          <div className="flex flex-wrap gap-2 mt-5">
            {rebuild.standards.map((s) => (
              <span key={s} className="text-[10px] font-mono uppercase tracking-widest px-2 py-1 border border-white/10 text-slate-400">{s}</span>
            ))}
          </div>
        </div>

        {/* 2D parametric preview */}
        <div>
          <div className="qs-panel p-4 h-[280px] flex flex-col-reverse items-center justify-start gap-1 overflow-hidden">
            {Array.from({ length: floors }).map((_, i) => (
              <motion.div key={`floor-${i}`}
                initial={{ opacity: 0, scaleY: 0 }} animate={{ opacity: 1, scaleY: 1 }}
                transition={{ delay: i * 0.04 }}
                className="w-3/4 origin-bottom"
                style={{
                  height: `${Math.max(10, 200 / floors)}px`,
                  background: `linear-gradient(180deg, ${material === 2 ? "#00FF7F33" : material === 1 ? "#00FFFF33" : "#8A2BE233"}, transparent)`,
                  border: `1px solid ${material === 2 ? "#00FF7F" : material === 1 ? "#00FFFF" : "#8A2BE2"}`,
                }}
              />
            ))}
            <div className="w-full h-2 bg-slate-700 mt-1" />
          </div>
          <div className="mt-4 flex items-center justify-between qs-panel p-4">
            <div className="flex items-center gap-2 text-sm text-slate-400"><Leaf className="h-4 w-4 text-[#00FF7F]" /> CO₂ saved vs. conventional</div>
            <span data-testid="rebuild-carbon" className="font-mono text-xl font-bold text-[#00FF7F]">{carbonSaved} tCO₂e</span>
          </div>
          <p className="text-xs text-slate-500 mt-3">{mat.name} — CO₂ factor {mat.co2_factor}. Target: {rebuild.target_performance}.</p>
        </div>
      </div>
    </div>
  );
};
